import { Helmet } from 'react-helmet-async';
// EKLENDİ: Video yüklenme durumunu takip etmek için 'useState' import edildi.
import { useEffect, useRef, useState } from 'react'; 
import BookCarousel from '../components/BookCarousel';
import CreateBookSection from '../components/CreateBookSection'; 
import PartnersSection from '../components/PartnerSection';
import SubscriptionSection from '../components/SubscriptionSection';
import EventsSection from '../components/EventsSection';
import { useTranslation } from 'react-i18next';


const Homepage = () => {
  const { t } = useTranslation();
  // EKLENDİ: Video'nun yüklenip oynanabilir olduğunu anlamak için state.
  const [isVideoLoaded, setIsVideoLoaded] = useState(false); 
  
  const sectionRefs = useRef([]);
  const scrollRef = useRef(null);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('cb-visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const refs = sectionRefs.current;
    refs.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      refs.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  useEffect(() => {
    const element = scrollRef.current;
    if (!element) return;

    const handleStart = (e) => {
      isDragging.current = true;
      startX.current = (e.pageX || e.touches[0].pageX) - element.offsetLeft;
      scrollLeft.current = element.scrollLeft;
      element.style.cursor = 'grabbing';
    };

    const handleMove = (e) => {
      if (!isDragging.current) return;
      e.preventDefault();
      const x = (e.pageX || e.touches[0].pageX) - element.offsetLeft;
      const walk = (x - startX.current) * 1.5;
      element.scrollLeft = scrollLeft.current - walk;
    };

    const handleEnd = () => {
      isDragging.current = false;
      element.style.cursor = 'grab';
    };

    element.addEventListener('mousedown', handleStart);
    element.addEventListener('mousemove', handleMove);
    element.addEventListener('mouseup', handleEnd);
    element.addEventListener('mouseleave', handleEnd);
    element.addEventListener('touchstart', handleStart);
    element.addEventListener('touchmove', handleMove);
    element.addEventListener('touchend', handleEnd);

    return () => {
      element.removeEventListener('mousedown', handleStart);
      element.removeEventListener('mousemove', handleMove);
      element.removeEventListener('mouseup', handleEnd);
      element.removeEventListener('mouseleave', handleEnd);
      element.removeEventListener('touchstart', handleStart);
      element.removeEventListener('touchmove', handleMove);
      element.removeEventListener('touchend', handleEnd);
    };
  }, []);

  const addToRefs = (el) => {
    if (el && !sectionRefs.current.includes(el)) {
      sectionRefs.current.push(el);
    }
  };

  return (
    <>
      <Helmet>
        <title>{t('homePage.meta.title')}</title>
        <link rel="canonical" href="https://studio.littlehibba.com" />
        <meta name="description" content={t('homePage.meta.description')} />
        <meta property="og:title" content={t('homePage.meta.title')} />
        <meta property="og:description" content={t('homePage.meta.description')} />
      </Helmet>

      {/* Hero Section */}
      <section className="video-section position-relative">
        {/* GÜNCELLENDİ: Video etiketi optimize edildi */}
        <video 
          autoPlay 
          loop 
          muted 
          playsInline 
          // EKLENDİ: Siyah ekran sorununu önlemek için poster resmi.
          poster="/videos/herovideo-poster.jpg"
          // EKLENDİ: Video oynanabilir olduğunda state'i güncelleyen event.
          onCanPlay={() => setIsVideoLoaded(true)}
          // EKLENDİ: Yumuşak geçiş efekti için state'e bağlı dinamik class.
          className={`hero-video ${isVideoLoaded ? 'loaded' : ''}`}
          // EKLENDİ: Tarayıcıya videonun sadece meta verilerini önceden yüklemesini söyler.
          preload="metadata" 
        >
          {/* EKLENDİ: Daha modern ve verimli WebM formatı öncelikli. */}
          <source src="/videos/herovideo.webm" type="video/webm" />
          {/* MP4, WebM desteklemeyen tarayıcılar için yedek olarak kalır. */}
          <source src="/videos/herovideo.mp4" type="video/mp4" />
          {t('homePage.videoNotSupported')}
        </video>
        <div className="hero-text-overlay">
          <span>{t('homePage.hero.line1')}</span>
          <span>{t('homePage.hero.line2')}</span>
        </div>
      </section>
      
      <EventsSection />
      
      <CreateBookSection t={t} addToRefs={addToRefs} />
      <BookCarousel addToRefs={addToRefs} />
      <PartnersSection />
      <SubscriptionSection t={t} addToRefs={addToRefs} />
         
    </>
  );
};

export default Homepage;